import { styled, keyframes, css } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Box } from '@moonpig/launchpad-components'
import { EnvelopeMoonpig } from './EnvelopeMoonpig'
import { EnvelopeGreetz } from './EnvelopeGreetz'

export const EnvelopeContainer = styled(Box)`
  position: relative;
  aspect-ratio: 1 / 1;
  scale: 1;
`

export const EnvelopeProviderContainer = styled('div')`
  position: absolute;
  bottom: 5%;
  right: 5%;
  width: 35%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  ${s({ bgcolor: 'colorBackground01' })}
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 5%;
`

const ANIMATION_START_DELAY = 500 // Delay before all animation starts
const ANIMATION_PIN_DELAY = 250 // Delay between each pin animation

const Animations = {
  cardRise: keyframes`
    0% {
      transform: translateY(25px);
    }
    100% {
      transform: translateY(0px);
    }
  `,
  pinFadeIn: keyframes`
    0% {
      opacity: 0;
      transform: translateY(15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  `,
}

const EnvelopeAnimationStyles = css`
  & .card,
  .pin {
    animation: ${Animations.cardRise} 2000ms ease-in-out forwards;
    animation-play-state: inherit;
    animation-delay: ${ANIMATION_START_DELAY}ms;
    transform: translateY(25px);
  }

  & .pin path {
    animation: ${Animations.pinFadeIn} 1500ms ease-in-out forwards;
    animation-play-state: inherit;
    opacity: 0;
  }

  ${Array.from({ length: 4 }).map(
    (_, i) => `
      & .pin path:nth-child(${i + 1}) {
        animation-delay: ${ANIMATION_START_DELAY + i * ANIMATION_PIN_DELAY}ms;
      }
    `,
  )}

  @media (prefers-reduced-motion: reduce) {
    & .pin path {
      animation: none !important;
      opacity: 1;
    }

    & .card,
    .pin {
      animation: none !important;
      transform: translateY(0) !important;
    }
  }
`

const BaseEnvelopeStyles = css`
  width: 100%;
  height: 100%;
  display: block;

  & .card {
    path {
      fill: white;
      clip-path: inset(0px 0px 10px 0px);
    }
  }

  animation-play-state: inherit;

  ${EnvelopeAnimationStyles}
`

export const StyledMoonpigEnvelope = styled(EnvelopeMoonpig)`
  ${BaseEnvelopeStyles}
`

export const StyledGreetzEnvelope = styled(EnvelopeGreetz)`
  ${BaseEnvelopeStyles}
`
